// Pure helpers for editing a plan's scheduled change (its `pending` version). No React in here.

// A plan has at most one pending version (a new save replaces it).
export const getPendingVersion = (versions) =>
    (versions || []).find((version) => version.status === "pending") || null;

// Fields of a version's `data` that never go back into the form.
const VERSION_ONLY_KEYS = ["_id", "startEffectiveDate", "endEffectiveDate", "pendingUpdate"];

/**
 * The form values for editing a scheduled change: the plan as it will be.
 * `version.data` is the plan with the same lookups as a row of the list (pay codes, earning groups,
 * groupings and the prohibition pay code as objects), so it goes onto the current record as it is.
 * It leaves out the fields a version never stores (status, audit fields): those come from
 * `pendingUpdate` (the raw saved fields) when the API returns it, else from the record.
 * The effective date starts as the version's start date.
 */
export const scheduledFormValues = (record, version) => {
    if (!record || !version) {
        return record;
    }
    const data = { ...(version.data || {}) };
    VERSION_ONLY_KEYS.forEach((key) => delete data[key]);

    const values = { ...record, ...data };
    Object.entries(version.pendingUpdate || {}).forEach(([key, value]) => {
        if (!(key in data) && key !== "effectiveDate" && !key.includes(".")) {
            values[key] = value;
        }
    });

    return {
        ...values,
        id: record.id,
        effectiveDate: version.startEffectiveDate,
    };
};
